import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { mtrRoutes } from './_mtr';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(mtrRoutes)
  ]
})
export class MtrModule { }
